import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { GET_INSTALLMENTS_DETAIL } from "../../apiRoutes";
import axiosAuth from "../../../axiosAuth";

export interface InstallmentDetailsResponse {
  data: any;
}

const fetchInstallmentDetailByInstallmentId = async (installmentId: string) => {
  const response = await axiosAuth.get<InstallmentDetailsResponse>(
    `${GET_INSTALLMENTS_DETAIL}${installmentId}`
  );
  return response.data;
};

export const useGetInstallmentByInstallmentIdQuery = (
  installmentId: string,
  queryParams?: Omit<
    UseQueryOptions<
      InstallmentDetailsResponse,
      Error,
      InstallmentDetailsResponse,
      ["installment-details", string]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<
    InstallmentDetailsResponse,
    Error,
    InstallmentDetailsResponse,
    ["installment-details", string]
  >({
    queryKey: ["installment-details", installmentId],
    queryFn: () => fetchInstallmentDetailByInstallmentId(installmentId),
    enabled: !!installmentId,
    ...(queryParams || {}),
  });


